import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { fetchFeedbackOverview } from "../../../views/Admin/Feedback/feedbackApi";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// The monthly feedback check-in (Admin / IT): responses in the last 30 days,
// who dismissed it this round, and the newest response.
const MonthlyFeedbackWidget = () => {
  const user = useSelector(selectUser);
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!user?.id) return;
    fetchFeedbackOverview(user.id)
      .then(setData)
      .catch(() => setFailed(true));
  }, [user?.id]);

  if (!data) {
    return (
      <WidgetFrame title="Monthly Feedback" to="/admin/feedback">
        <WidgetEmpty>{failed ? "Couldn't load feedback." : "Loading feedback…"}</WidgetEmpty>
      </WidgetFrame>
    );
  }

  const { totals, latest } = data;

  return (
    <WidgetFrame title="Monthly Feedback" to="/admin/feedback">
      <div className="grid grid-cols-3 gap-2">
        <WidgetStat value={totals.last30} label="Last 30 days" />
        <WidgetStat value={totals.dismissed} label="Dismissed" />
        <WidgetStat value={totals.due} label="Due now" />
      </div>
      {latest && (
        <p className="app-muted mt-2 truncate text-xs">
          Latest: “{latest.message}” · {latest.name}
        </p>
      )}
    </WidgetFrame>
  );
};

export default MonthlyFeedbackWidget;
